import React, { useEffect,useState } from 'react';

import styles from './AccordionSelector.module.scss';

const AccordionSelector = ({ provinces, cities, onChange }) => {
  const [expanded, setExpanded] = useState({});
  const [selectedCities, setSelectedCities] = useState({});


  useEffect(() => {
    if (onChange) {
      const flatSelectedIds = Object.values(selectedCities).flat();
      const selectedCityObjects = cities.filter(city => flatSelectedIds.includes(city.id));
      onChange(selectedCityObjects);
    }
  }, [selectedCities, cities, onChange]);

  const toggleProvince = (provinceId) => {
    setExpanded(prev => ({ ...prev, [provinceId]: !prev[provinceId] }));
  };

  const toggleCity = (provinceId, cityId) => {
    setSelectedCities(prev => {
      const provinceCities = prev[provinceId] || [];
      const isSelected = provinceCities.includes(cityId);
      const updatedCities = isSelected
        ? provinceCities.filter(id => id !== cityId)
        : [...provinceCities, cityId];
      return { ...prev, [provinceId]: updatedCities };
    });
  };

  const toggleSelectAll = (provinceId, allCityIds) => {
    setSelectedCities(prev => {
      const alreadySelected = prev[provinceId] || [];
      const isAllSelected = alreadySelected.length === allCityIds.length;
      return {
        ...prev,
        [provinceId]: isAllSelected ? [] : allCityIds,
      };
    });
  };

  return (
    <div className={styles['accordion-selector']}>
      {provinces.map((prov) => {
        const provinceCities = cities.filter(city => city.province === prov.id);
        const allCityIds = provinceCities.map(c => c.id);
        const selectedInProvince = selectedCities[prov.id] || [];
        const allSelected = selectedInProvince.length === allCityIds.length;

        return (
          <div key={prov.id} className={styles['province-section']}>
            <div
              className={`${styles['province-header']} ${selectedInProvince.length > 0 ? styles['highlighted'] : ''}`}
              onClick={() => toggleProvince(prov.id)}
            >
              <strong>{prov.name}</strong>
              <label>
                <input
                  type="checkbox"
                  checked={allSelected}
                  style={{ marginRight: '5px' }}
                  onChange={() => toggleSelectAll(prov.id, allCityIds)}
                  onClick={(e) => e.stopPropagation()}
                />
                {`  Select All`}
              </label>
            </div>

            {expanded[prov.id] && (
              <ul className={styles['city-list']}>
                {provinceCities.map(city => (
                  <li key={city.id}>
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedInProvince.includes(city.id)}
                        onChange={() => toggleCity(prov.id, city.id)}
                      />
                      {' '}{city.name}
                    </label>
                  </li>
                ))}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AccordionSelector;

// export default (CSSModule(AppWrapper, styles, { allowMultiple: true }));